import React, { useState } from "react";

export default function App() {
  const [budget, setBudget] = useState("");
  const [purpose, setPurpose] = useState("");
  const [mustHave, setMustHave] = useState("");
  const [customSerial, setCustomSerial] = useState(false);
  const [serialText, setSerialText] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = {
      budget,
      purpose,
      mustHave,
      customSerial,
      serialText: customSerial ? serialText : null,
      name,
      email,
    };
    console.log("Submitted Data:", data);
    alert("Build request submitted! We'll follow up soon.");
  };

  return (
    <div style={{ background: "#111", color: "#fff", padding: "2rem", maxWidth: "600px", margin: "auto", borderRadius: "12px" }}>
      <h2 style={{ fontSize: "1.8rem", marginBottom: "1rem" }}>Build Your Custom AR</h2>
      <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        <div>
          <label>Budget Range</label>
          <select value={budget} onChange={(e) => setBudget(e.target.value)} required style={{ width: "100%", padding: "0.5rem" }}>
  <option value="">Select your budget</option>
  <option value="500-1000">$500–$1,000</option>
  <option value="1000-2000">$1,000–$2,000</option>
  <option value="2000-3000">$2,000–$3,000</option>
  <option value="3000-4000">$3,000–$4,000</option>
  <option value="4000-5000">$4,000–$5,000</option>
  <option value="5000+">$5,000+</option>
</select>
        </div>

        <div>
          <label>Primary Purpose</label>
          <select value={purpose} onChange={(e) => setPurpose(e.target.value)} required style={{ width: "100%", padding: "0.5rem" }}>
            <option value="">Select purpose</option>
            <option value="Competition">Competition</option>
            <option value="CQB">CQB / Home Defense</option>
            <option value="Hunting">Hunting</option>
            <option value="Plinking">Plinking</option>
            <option value="All-Around">All-Around</option>
          </select>
        </div>

        <div>
          <label>Must-Have Features</label>
          <textarea value={mustHave} onChange={(e) => setMustHave(e.target.value)} rows="3" style={{ width: "100%", padding: "0.5rem" }} placeholder="e.g. LPVO, folding stock, ambi controls..." />
        </div>

        <div>
          <label>
            <input type="checkbox" checked={customSerial} onChange={(e) => setCustomSerial(e.target.checked)} />
            {" "}Custom Serial Number?
          </label>
          {customSerial && (
            <input type="text" value={serialText} onChange={(e) => setSerialText(e.target.value)} placeholder="Preferred serial text" style={{ width: "100%", marginTop: "0.5rem", padding: "0.5rem" }} />
          )}
        </div>

        <input type="text" value={name} onChange={(e) => setName(e.target.value)} required placeholder="Your Name" style={{ padding: "0.5rem" }} />
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="Your Email" style={{ padding: "0.5rem" }} />

        <button type="submit" style={{ background: "#28a745", padding: "0.75rem", color: "#fff", border: "none", borderRadius: "6px", fontWeight: "bold" }}>
          Submit Build Request
        </button>
      </form>
    </div>
  );
}
